import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import mouseWheelZoom from "highcharts/modules/mouse-wheel-zoom";
mouseWheelZoom(Highcharts);

const CombinedChart = ({ barChartData, lineChartData, colorCode,unit = "MW" }) => {

  // Merge barChartData and lineChartData by plant_id
  const combinedData = barChartData.map((barItem, index) => {
    const lineItem =
      lineChartData.find((item) => item.plant_id === barItem.plant_id) || {};
    return {
      plant_id: barItem.plant_id,
      plant_name: barItem.plant_name,
      plant_capacity: barItem.plant_capacity || 0, // Default to 0 if missing
      generation_value: lineItem.generation_value || 0, // Default to 0 if missing
      color: colorCode[lineItem.plant_id],
    };
  });


  // Handle missing line chart data if there are extra items in lineChartData
  lineChartData.forEach((lineItem) => {
    if (
      !barChartData.some((barItem) => barItem.plant_id === lineItem.plant_id)
    ) {
      combinedData.push({
        plant_id: lineItem.plant_id,
        plant_name: lineItem.plant_name,
        plant_capacity: 0, // Default to 0 for missing bar chart data
        generation_value: lineItem.generation_value,
      });
    }
  });

  // Calculate average values for the combined dataset
  const averageData = combinedData.map((item) => {
    return (item.plant_capacity + item.generation_value) / 2;
  });

  // Dynamically calculate the minimum values for each y-axis
  const minMW = Math.min(0, ...combinedData.map((item) => item.plant_capacity));
  const minBU = Math.min(
    0,
    ...combinedData.map((item) => item.generation_value)
  );

  const options = {
    chart: {
      zooming: { mouseWheel: { enabled: true, type: "x" } },
      type: "column",
      height: 300,
    },
    scrollbar: {
      enabled: true,
    },
    title: {
      text: null, // No title
    },
    xAxis: {
      categories: combinedData.map((item) => item.plant_name), // Use plant_name as categories
     
    },
    exporting: {
      enabled: false, // Disable exporting
    },
    yAxis: [
      {
        title: { text: "MW (Capacity DC)" },
        gridLineDashStyle: "Dash",
        gridLineWidth: 1,
        gridLineColor: "#e0e0e0",
        lineWidth: 1,
        lineColor: "#e0e0e0",
        opposite: false,
      },
      {
        title: { text: `${unit} (Generation)` },
        linkedTo: 0, // <-- Ensures same scale as first axis
        opposite: true,
        gridLineWidth: 0, // Optional: avoid double grid lines
      },
    ],
    
    tooltip: {
      enabled: true,
    },
    
    
    credits: {
      enabled: false, // Remove the Highcharts logo
    },
    legend: {
      enabled: false, // Remove the legend
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        borderRadius: 5,
        groupPadding: 0.1,
        pointPadding: 0.1,
      },
      line: {
        lineWidth: 1,
        marker: {
          enabled: true,
          radius: 4,
          symbol: "circle",
          fillColor: "#FFFFFF",
          lineWidth: 1,
          lineColor: "black",
        },
      },
    },
    series: [
      {
        name: "MW",
        type: "column",
        data: combinedData.map((item) => item.plant_capacity),
        colorByPoint: true,
        colors: combinedData.map((e) => e.color),
        yAxis: 0,
        dataLabels: {
          enabled: false,
        },
      },
      {
        name: unit,
        type: "line",
        data: combinedData.map((item) => item.generation_value), // Use generation_value for MW data
        color: "#45748b",
        yAxis: 1,
        dataLabels: {
          enabled: false,
        },
      },
      // {
      //   name: "Average",
      //   type: "line",
      //   data: averageData.map((value) => value), // Average of bar and line data
      //   color: "#4CAF50",
      //   dashStyle: "Dash",
      //   marker: {
      //     enabled: false,
      //   },
      //   enableMouseTracking: true,
      //   yAxis: 0, // Align with the MW axis
      // },
    ],
  };

  return (
    <>
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </>
  );
};

export default CombinedChart;